import * as PIXI from "pixi.js";

export class UIButton extends PIXI.Container {
    private background: PIXI.Graphics;
    private selectedFrame: PIXI.Graphics;
    private data: any;
    private betLabel: PIXI.Text;

    public static WIDTH: number = 140;
    public static HEIGHT: number = 70;

    constructor(text: string, width: number = UIButton.WIDTH, height: number = UIButton.HEIGHT) {
        super();

        // Create a rounded rectangle for the button
        this.background = new PIXI.Graphics();
        this.background.roundRect(-width / 2, -height / 2, width, height, height / 2); // Rounded rect
        this.background.fill(0x000000); // Blue color
        this.background.stroke({ width: 3, color: 0x333333 });

        this.selectedFrame = new PIXI.Graphics();
        this.selectedFrame.roundRect(-width / 2, -height / 2, width, height, height / 2); // Rounded rect
        this.selectedFrame.stroke({ width: 3, color: 0xffffff });

        this.background.strokeStyle.width = 3;
        this.addChild(this.background);
        this.addChild(this.selectedFrame);

        this.unselect();

        // Create the label
        this.betLabel = new PIXI.Text({
            text,
            style: {
                fill: "#ffffff",
                fontSize: 30,
                fontWeight: "bold",
                align: "center",
            }
        });
        this.betLabel.anchor.set(0.5);
        this.betLabel.position.set(0, 0); // Center in the button
        this.addChild(this.betLabel);

        // Add click listener
        this.interactive = true;
        this.on("pointerup", () => {
            this.emit('onSelect', this);
        });
    }

    setData (data: any) {
        this.data = data;
    }

    getData () {
        return this.data;
    }

    select() {
        this.selectedFrame.visible = true;
    }

    unselect() {
        this.selectedFrame.visible = false;;
    }
}
